export default {
  data() {
    return {};
  },
  props: {
    outline: {
      type: Boolean,
      default: false
    },
    severity: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Submit'
    },
    progress: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'submit'
    },
    color: {
      type: String,
      default: '#4F4F4F'
    }
  },
  emits: ['change-event'],
  methods: {
    changeEvent() {
      this.$emit('change-event');
    }
  }
};
